import React from 'react'
import Header from '../standartComponents/header'
import css from './info.module.css';
import Policies from '../standartComponents/policies';
import { useTranslation } from 'react-i18next';

const TermsOfUse = ({authUser}) => {
  const { t } = useTranslation();
  return (
    <div>
    <Header authUser={authUser} />  
    <div className={css.termsContainer}>
        <div className={css.contentWrapper}>
          <h1 className={css.pageTitle}>{t("Terms of Use2")}</h1>
          <span className={css.bottomLine}></span>
          <p className={css.lastUpdated}>{t("Last updated")}: 14 {t("October")} 2025</p>
          
          <div className={css.section}>
            <h2 className={css.sectionTitle}>1. {t("About Us")}</h2>
            <p className={css.sectionText}>
              {t("temrs1Text")}
            </p>
            <p className={css.sectionText}>
              {t("terms2")}
            </p>
            <p className={css.sectionText}>
              {t("terms3")}<br/>
              Email: <a href="mailto:ailinguaservice@gmail.com">ailinguaservice@gmail.com</a> | {t("Tel")}: <a href="tel:+380682507477">+380 68 250 74 77</a> | {t("terms4")}<br/>
              {t("terms5")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>2. {t("Accounts and Age")}</h2>
            <p className={css.sectionText}>
              {t("terms6")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>3. {t("Subscriptions, Pricing, and Billing")}</h2>
            <p className={css.sectionText}>
              <strong>{t("terms7")}</strong> {t("terms8")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>4. {t("Trial Period and Free Version")}</h2>
            <p className={css.sectionText}>
              {t("terms9")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>5. {t("Refunds")}</h2>
            <p className={css.sectionText}>
              {t("terms10")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>6. {t("Acceptable Use")}</h2>
            <p className={css.sectionText}>
              {t("terms11")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>7. {t("Intellectual Property Rights")}</h2>
            <p className={css.sectionText}>
              {t("terms12")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>8. {t("Third-Party Technologies and AI")}</h2>
            <p className={css.sectionText}>
              {t("terms13")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>9. {t("Service Availability and Changes")}</h2>
            <p className={css.sectionText}>
              {t("terms14")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>10. {t("Termination of Access")}</h2>
            <p className={css.sectionText}>
              {t("terms15")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>11. {t("Warranty Disclaimer")}</h2>
            <p className={css.sectionText}>{t("terms16")}</p>
       </div>
       <div className={css.section}>
        <h2 className={css.sectionTitle}>12. {t("Governing Law and Contact")}</h2>
        <p className={css.sectionText}>{t("terms17")}</p>
        <p className={css.sectionText}>{t("terms18")} <a href="mailto:ailinguaservice@gmail.com">ailinguaservice@gmail.com</a>.</p>
       </div>
       </div>
       </div>
       <Policies />
       </div>
       )
            }

export default TermsOfUse;